import Backbone from 'backbone';
import BubbleModel from '../models/BubbleModel.js';
import $ from 'jquery';

// Set up Backbone to use jQuery
Backbone.$ = $;

// Bubble Collection for managing multiple bubbles
const BubbleCollection = Backbone.Collection.extend({

  // Specify the model this collection contains
  model: BubbleModel,

  // URL for collection operations (fetch, create)
  url: function() {
    const backboneUrl = process.env.REACT_APP_BACKBONE_URL || 'https://ppb.chatforest.com';
    return `${backboneUrl}/api/bubbles`;
  },

  // Parse the response from server
  // DreamHost PHP backend might return data in different format
  parse: function(response) {
    // If response is wrapped in an object, extract the array
    if (response.bubbles && Array.isArray(response.bubbles)) {
      return response.bubbles;
    }
    // If response is already an array, return as-is
    if (Array.isArray(response)) {
      return response;
    }
    // Otherwise, wrap single item in array
    return [response];
  },

  // Comparator for sorting bubbles (largest first, then by name)
  comparator: function(bubble) {
    return [-bubble.get('size'), bubble.get('name')];
  },

  // Custom methods for collection-level operations

  // Get bubbles by team
  getByTeam: function(teamId) {
    return this.filter(function(bubble) {
      return bubble.get('teamId') === teamId;
    });
  },

  // Get bubbles larger than specified size
  getLargerThan: function(size) {
    return this.filter(function(bubble) {
      return bubble.get('size') > size;
    });
  },

  // Get top N bubbles by size
  getTopBubbles: function(count = 10) {
    return this.sortBy(function(bubble) {
      return -bubble.get('size'); // Negative for descending order
    }).slice(0, count);
  },

  // Calculate total size of all bubbles
  getTotalSize: function() {
    return this.reduce(function(total, bubble) {
      return total + bubble.get('size');
    }, 0);
  },

  // Get team statistics
  getTeamStats: function() {
    const stats = {};
    this.each(function(bubble) {
      const team = bubble.get('team');
      if (!stats[team]) {
        stats[team] = {
          count: 0,
          totalSize: 0,
          averageSize: 0,
          bubbles: []
        };
      }
      stats[team].count += 1;
      stats[team].totalSize += bubble.get('size');
      stats[team].bubbles.push(bubble);
    });

    // Calculate averages
    Object.keys(stats).forEach(team => {
      stats[team].averageSize = stats[team].totalSize / stats[team].count;
    });

    return stats;
  },

  // Override sync to handle CORS and authentication
  sync: function(method, collection, options) {
    options = options || {};

    // Add cache-busting for GET requests to ensure fresh data
    if (method === 'read') {
      const url = this.url();
      const separator = url.includes('?') ? '&' : '?';
      options.url = url + separator + '_t=' + Date.now();
    }

    // Add CORS and authentication headers
    options.beforeSend = function(xhr) {
      xhr.setRequestHeader('Content-Type', 'application/json');
      // Add any authentication headers if needed
      // xhr.setRequestHeader('Authorization', 'Bearer ' + token);
    };

    // Remove credentials for CORS (PHP API doesn't need them)
    options.xhrFields = {
      withCredentials: false
    };

    return Backbone.sync(method, collection, options);
  }

});

export default BubbleCollection;
